define([], function () {
    function Init() {
        let options = {
            selector: ['.lazy'],
            threshold: 0.01,
            rootMargin: '100px 0px 100px 0px',
        };
        let resources = document.querySelectorAll('.lazy');
        
        const assetsObserver = new IntersectionObserver((entries, assetsObserver) => {
            entries.filter(entry => entry.isIntersecting).forEach(entry => {
                _lazyLoadAsset(entry.target);
                assetsObserver.unobserve(entry.target);
            });
        }, options);
        resources.forEach(resource => {
            assetsObserver.observe(resource);
        });
    }

    function _lazyLoadAsset(asset) {
        const src = asset.getAttribute('data-src');
        if (src) {
            asset.src = src;
        }
        asset.classList.remove('lazy');
    }

    return {
        Init: Init
    };
});